<div class="PremiumInfo">
    <div class="Loading" *ngIf="isShowLoading==true">
        <img id="" src="assets/img/762.gif" />
        <label>{{'Please Wait,Processing..'|translate }}</label>
    </div>

    <div class="alert alert-danger" *ngIf="prObj.st.StatusCode=='F'">
        <strong>{{Lng=='ar'?prObj.st.StatusDescAr:prObj.st.StatusDesc }}.</strong>
    </div>
    <div class="alert alert-danger" *ngIf="prObj.PromoRes.st.StatusCode=='F'">
        <strong>{{Lng=='ar'?prObj.PromoRes.st.StatusDescAr:prObj.PromoRes.st.StatusDesc }}.</strong>
    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <div class="card" style="width:100%;" id="InsuredInfo">
            <ul class="nav nav-tabs listdata" role="tablist">
                <li role="presentation" class="active">
                    <a href="#home" aria-controls="home" role="tab" data-toggle="tab"> {{'Premium Details'| translate }}</a>
                </li>

            </ul>
            <div class="tab-content detailsTab">
                <div role="tabpanel" class="tab-pane active" id="home">

                    <div class="row">
                        <div class="col-lg-6 col-md-8 col-sm-9 col-xs-12">
                            <div class="PolicyPeriodInfo">

                                <div class="card" style="width:100%;">
                                    <ul class="nav nav-tabs Sublistdata" role="tablist">
                                        <li role="presentation" class="active">
                                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab"> {{'TPL Price' | translate }} </a>

                                        </li>

                                    </ul>
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active PolicyInfo Premium">

                                            <label>
                                                <span class="lbltext"> {{'Basic Premium' | translate }}:</span>
                                                <span>{{prObj.BasicPremium | number : '1.2-2' }}</span>

                                            </label>
                                            <label *ngIf="prObj.Adminfee">
                                                <span class="lbltext"> {{'Adminfee' | translate }}:</span>
                                                <span>{{prObj.Adminfee | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="prObj.AgeLoading">
                                                <span class="lbltext"> {{'Age Loading' | translate }}:</span>
                                                <span>{{prObj.AgeLoading | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="prObj.DriverCase">
                                                <span class="lbltext"> {{'Accident Loading' | translate }}:</span>
                                                <span>{{prObj.DriverCase | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="prObj.AddDriverChk">
                                                <span class="lbltext"> {{'DAB'| translate }}:</span>
                                                <span>{{prObj.AddDriverAmt | number : '1.2-2'}}</span>

                                            </label>
                                            <label *ngIf="prObj.AddPassChk">
                                                <span class="lbltext"> {{'PAB' | translate }}:</span>
                                                <span>{{prObj.AddPassAmt | number : '1.2-2'}}</span>

                                            </label>

                                            <label>
                                                <span class="lbltext"> {{'Gross Premium' | translate }}:</span>
                                                <span>{{prObj.GrossPremium | number : '1.2-2'}}</span>

                                            </label>
                                            <label>
                                                <span class="lbltext"> {{'NCD' | translate }}:</span>
                                                <span>{{prObj.NCDDiscountAmt | number : '1.2-2'}}({{prObj.NCDPercent | number :
                                                    '1.2-2'}}%)</span>

                                            </label>
                                            <label *ngIf="prObj.LDAmount>0">
                                                <span class="lbltext">{{'LD' | translate }}:</span>
                                                <span>{{prObj.LDAmount | number : '1.2-2'}}({{prObj.LDPercentage | number : '1.2-2'}}%)</span>

                                            </label>
                                            <label *ngIf="prObj.DriverDiscountAmt">
                                                <span class="lbltext">{{'Female Discount' | translate }} :</span>
                                                <span>{{prObj.DriverDiscountAmt | number : '1.2-2'}}({{prObj.DriverDiscPer | number
                                                    : '1.2-2'}}%)</span>

                                            </label>
                                            <label *ngIf="prObj.CrossSellDiscountAmt>0">
                                                <span class="lbltext"> {{'CrossSellDiscount' | translate }}:</span>
                                                <span>{{prObj.CrossSellDiscountAmt | number : '1.2-2'}}({{prObj.CrossSellDiscountPer
                                                    }}%)</span>

                                            </label>
                                            <label *ngIf="prObj.PromoDiscount">
                                                <span class="lbltext"> {{'Promo Discount' | translate}}:</span>
                                                <span>{{prObj.PromoDiscount | number : '1.2-2'}}({{prObj.PromoPercent | number
                                                    : '1.2-2' }}%)</span>
                                            </label>
                                            
                                            <label>
                                                <span class="lbltext"> {{'Total(Excluding VAT)' | translate}}:</span>
                                                <span>{{prObj.TotPremiumBVAT | number : '1.2-2'}}</span>

                                            </label>

                                            <label>
                                                <span class="lbltext"> {{'VAT' | translate}}:</span>
                                                <span>{{prObj.VATAmount | number : '1.2-2'}}({{ prObj.VATPercent | number : '1.2-2'
                                                    }}%)</span>

                                            </label>
                                            <label>
                                                <span class="lbltext"> {{'UPR VAT' | translate}}:</span>
                                                <span>{{prObj.UPR_VAT_AMOUNT | number : '1.2-2'}}</span>

                                            </label>

                                            <label class="Total">
                                                <span> {{'Total'| translate }}:</span>
                                                <span>{{prObj.TotalPremium | number : '1.2-2'}}</span>

                                            </label>
                                            <!-- <label style="color:red;">Total: 1684 SAR</label>  -->
                                            <div class="btncomprehensivediv">
                                                <button class="btn btn-primary" data-toggle="modal" data-target="#AdditionalCoversModal" [disabled]="prObj.isPromoApply=='Y'">{{'Add More Covers' | translate}}</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>


                    <div class="row">

                        <div class="promo">
                            <div class="Field">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <label class="lbltext"> {{'Do you have promo code?' | translate }}</label>
                                    </div>
                                    <div class="col-lg-12 row promoapplydiv">
                                        <!-- <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10"> -->
                                        <div class="col-lg-5 col-md-5 col-sm-6 col-xs-6">
                                            <input class="form-control" id="txtPromo" id="txtPromo" placeholder="Promo Code" type="text" [(ngModel)]="prObj.PromoReq.PROMOCODE"
                                                [disabled]="prObj.isPromoApply=='Y'">
                                        </div>
                                        <div class="col-lg-4 col-md-5 col-sm-6 col-xs-6">
                                            <button class="btn btn-primary renewalPromoBtn" id="btnRenewalPromo" name="btnRenewalPromo" [disabled]="prObj.isPromoApply=='Y'"
                                                (click)="ApplyRenewalPromo()">{{'Apply' | translate }}</button>
                                        </div>


                                        <!-- </div> -->
                                        <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2" style="padding-left:0px;">
                                                                                     <button class="btn btn-primary btns" style="float:left;">Apply</button>
                                                                                     </div> -->


                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="row">
                        <hr class="hr" />
                    </div>

                    <div class="ButtonActions ButtonActionsAr">
                        <div class="btn-group">
                            <button class="btn btn-primary" name="btnPrev" id="btnPrev" (click)="goPrev()">{{'Prev' | translate }}</button>
                            <button class="btn btn-primary" name="btnNext" id="btnNext" (click)="goNext()">{{'Next' | translate }}</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>



<div class="clears">

</div>

<!-- Additional TPL Covers -->
<div class="modal fade" id="AdditionalCoversModal" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <button type="button" class="close" data-dismiss="modal">&times;</button>
                <h4 class="modal-title logins">{{'Additional TPL Covers' | translate }}</h4>
            </div>
            <div class="modal-body">

                <div class="ComprensivePremium">
                    <form #tplCoverForm="ngForm">
                        <table class="table table-striped tabledesign">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{{'Cover Description'|translate}} </th>
                                    <th style="min-width:130px">{{'Total Price' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <input id="txtSelected" name="txtSelected" type="checkbox" style="zoom:1.3" [(ngModel)]="prObj.AddDriverChk"
                                            (change)="addDABCover(prObj.AddDriverChk)" />
                                    </td>
                                    <td>{{'DAB' | translate}}</td>
                                    <td>{{ prObj.AddDriverAmt | number : '1.2-2' }}</td>
                                </tr>
                                <tr>
                                    <td>
                                        <input id="txtSelected" name="txtSelected" type="checkbox" style="zoom:1.3" [(ngModel)]="prObj.AddPassChk"
                                            (change)="addPABCover(prObj.AddPassChk)" />
                                    </td>
                                    <td>{{'PAB' | translate }}</td>
                                    <td>{{ prObj.AddPassAmt | number : '1.2-2' }}</td>
                                </tr>
                                <!-- <tr *ngFor="let tplCover of prObj.tplCovers;let i=index;">
                                        <td>
                                            <input id="txtSelected" name="txtSelected" type="checkbox" style="zoom:1.3" [(ngModel)]="tplCover.isSelected"  [disabled]="tplCover.isman"  (change)="calcPremium(tplCover.CoverCode)"
                                            />
                                        </td>
                                        <td>{{i+1}}</td>
                                        <td>{{ Lng=="en" ? tplCover.CoverDescription:tplCover.CoverDescription_Ar}}</td>
                                        <td>{{tplCover.GrossAmount | number : '1.2-2'}}</td>
                                    </tr>-->
                            </tbody>
                        </table>


                        <div class="Actionsection">
                            <div class="Actions">
                                <div class="btn-group">
                                    <!--(click)="test()"-->
                                    <button type="button" class="btn btn-primary btns procced" data-dismiss="modal">{{'Close' | translate }}</button>

                                </div>
                            </div>
                        </div>
                    </form>

                </div>


            </div>

        </div>
    </div>

</div>
<!-- Additional TPL Covers -->


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/RenewalPremiumInfo/RenewalPremiumInfo.html